import React from "react";
import Main from "./components/Main";
import './components/style.css'

function App() {
  return (
    <>
    <Main></Main>
    </>
  );
}

export default App;